/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type GeneralInfoTabsUpdateFaqsMutationVariables = {|
  valueFaqs: string
|};
export type GeneralInfoTabsUpdateFaqsMutationResponse = {|
  +staticUrlContent: ?{|
    +file: ?string
  |}
|};
export type GeneralInfoTabsUpdateFaqsMutation = {|
  variables: GeneralInfoTabsUpdateFaqsMutationVariables,
  response: GeneralInfoTabsUpdateFaqsMutationResponse,
|};
*/


/*
mutation GeneralInfoTabsUpdateFaqsMutation(
  $valueFaqs: String!
) {
  staticUrlContent(input: {type: FAQS, content: $valueFaqs, lang: "es"}) {
    file
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "valueFaqs",
    "type": "String!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "content",
            "variableName": "valueFaqs"
          },
          {
            "kind": "Literal",
            "name": "lang",
            "value": "es"
          },
          {
            "kind": "Literal",
            "name": "type",
            "value": "FAQS"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "StaticUrlContentPayload",
    "kind": "LinkedField",
    "name": "staticUrlContent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "file",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GeneralInfoTabsUpdateFaqsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GeneralInfoTabsUpdateFaqsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "GeneralInfoTabsUpdateFaqsMutation",
    "operationKind": "mutation",
    "text": "mutation GeneralInfoTabsUpdateFaqsMutation(\n  $valueFaqs: String!\n) {\n  staticUrlContent(input: {type: FAQS, content: $valueFaqs, lang: \"es\"}) {\n    file\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9afd8cf940eb919f4869abeda2ad9a67';

module.exports = node;
